import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"
import { AdminFeedbackRoute } from "./-FeedbackPage"

// ─────────────────────────────────────────────────────────────────────────────
// URL search param schema — `?id=X` drives the selected-row state.
// ─────────────────────────────────────────────────────────────────────────────

const adminFeedbackSearchSchema = z.object({ id: z.string().optional() }).partial()

export const Route = createFileRoute("/admin/feedback" as any)({
  validateSearch: adminFeedbackSearchSchema,
  component: AdminFeedbackRoute,
})
